// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { ClientApplication } from '../../client';
import type {
  FilmEditHistory,
  FilmEditHistoryData,
  FilmEditHistoryQuery,
  FilmEditHistoryService,
} from './film-edit-history.class';

export type { FilmEditHistory, FilmEditHistoryData, FilmEditHistoryQuery };

export type FilmEditHistoryClientService = Pick<
  FilmEditHistoryService,
  (typeof filmEditHistoryMethods)[number]
>;

export const filmEditHistoryPath = '/api/film-edit-history';

export const filmEditHistoryMethods: Array<keyof FilmEditHistoryService> = [
  'find',
  'get',
  'create',
];

export const filmEditHistoryClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(filmEditHistoryPath, connection.service(filmEditHistoryPath), {
    methods: filmEditHistoryMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [filmEditHistoryPath]: FilmEditHistoryClientService;
  }
}
